import { useState } from "react";
import { Link, Redirect } from "wouter";
import { useAuth } from "../hooks/useAuth";
import { BrandIcon, Wordmark } from "../components/Brand";
import { JoinQrScanner } from "../components/JoinQrScanner";

export function WelcomePage() {
  const { isAuthenticated } = useAuth();
  const [scannerOpen, setScannerOpen] = useState(false);
  if (isAuthenticated) return <Redirect to="/cards" />;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center max-w-md mx-auto">
      <BrandIcon size={96} />
      <div className="mt-6">
        <Wordmark size="lg" />
      </div>
      <p className="mt-8 text-ink-dark text-lg leading-relaxed">
        Scan any M42 merchant&apos;s Join QR
        <br />
        to get started.
      </p>

      <div className="mt-10 w-full flex flex-col gap-3">
        <button
          type="button"
          onClick={() => setScannerOpen(true)}
          className="btn-primary w-full text-center"
          data-testid="button-open-scanner-welcome"
        >
          Open camera to scan
        </button>
        <Link
          href="/signup"
          className="btn-secondary w-full text-center"
          data-testid="link-create-orbit"
        >
          Create your Orbit
        </Link>
        <Link
          href="/login"
          className="text-sm text-navy underline"
          data-testid="link-sign-in"
        >
          I already have an Orbit
        </Link>
      </div>

      <p className="mt-12 text-sm text-ink-dark/70">
        One card. Many merchants. Across the M42 ecosystem.
      </p>

      {/* Phase 28 — public entry into the standalone merchant signup
          flow. Kept visually de-emphasized (small text below the
          ecosystem tagline) so it doesn't compete with the customer
          CTAs above; merchants who arrive here already know what
          they're looking for. */}
      <p className="mt-4 text-sm text-ink-dark">
        Are you a merchant?{" "}
        <Link
          href="/for-merchants"
          className="text-navy underline"
          data-testid="link-for-merchants"
        >
          Sign up for free
        </Link>
      </p>

      {scannerOpen && (
        <JoinQrScanner
          onClose={() => setScannerOpen(false)}
          onShortCode={(shortCode) => {
            // D98 — see Cards.tsx; full-page navigation (not wouter
            // navigate) so the unauthenticated Welcome → Join
            // transition matches the native-camera path and never
            // gets a blank JoinPage from a stalled React commit
            // behind the camera tear-down.
            setScannerOpen(false);
            window.location.assign(`/j/${shortCode}`);
          }}
        />
      )}
    </div>
  );
}
